var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print-card",attrs:{"data-testid":_vm.testId}},[_c('h2',{staticClass:"print-card__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"print-card__content",class:{ 'card-padding': _vm.hasPadding },attrs:{"data-private":""}},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }